import React from "react";
import "../../css/DesignSystem/TableInputFields.css";

class TableInputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
    };
  }

  handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const dayOfWeek = selectedDate.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      this.setState({
        error: "Weekends are not allowed. Please select a weekday.",
      });
      e.target.value = "";
    } else {
      this.setState({ error: "" });
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  render() {
    const {
      name,
      label,
      placeholder,
      required,
      value,
      onChange,
      onClick,
      isTextarea,
      specialType,
      min,
    } = this.props;

    return (
      <div className="table-input-group">
        {/* {label && <div className="Content-Small">{`${label}:`}</div>} */}
        {label && (
          // <div className="tabelLabelContainer">
            <div className="Content-Small">
              {label}
              {typeof label === "string" ? ":" : null}
            </div>
          // </div>
        )}
        <input
          id={name}
          min={min}
          onClick={onClick}
          type={specialType || "text"}
          name={name}
          // isTextarea={isTextarea}
          placeholder={placeholder}
          className="table-input Content"
          required={required}
          value={value}
          onChange={specialType === "date" ? this.handleDateChange : onChange}
        />
      </div>
    );
  }
}

export default TableInputField;
